import type { CarbonIconType } from "@carbon/icons-react";
import { ChevronDown } from "@carbon/icons-react";
import { type ButtonProps as HeroButtonProps, Spinner } from "@heroui/react";
import type { ReactNode } from "react";
import { BUTTON_ICON_SIZE_CLASS } from "./buttonConstants";

interface ButtonContentProps {
  icon?: CarbonIconType;
  label?: ReactNode;
  children?: ReactNode;
  dropdownChevron?: boolean;
  size: NonNullable<HeroButtonProps["size"]>;
  isLoading?: boolean;
  isIconOnly?: boolean;
}

export default function ButtonContent({
  icon: Icon,
  label,
  children,
  dropdownChevron,
  size,
  isLoading,
  isIconOnly,
}: ButtonContentProps) {
  const startIcon = isLoading ? (
    <Spinner color="current" className="size-5" />
  ) : Icon ? (
    <Icon className={BUTTON_ICON_SIZE_CLASS[size]} />
  ) : null;
  const endIcon = dropdownChevron ? <ChevronDown /> : null;
  // Icon-only buttons pass the icon as children; loading replaces it entirely.
  const showChildContent =
    !isLoading || !isIconOnly || label != null || Icon != null;

  return (
    <>
      {startIcon}
      {showChildContent && (
        // Undo v3's content-svg size clamp; low-specificity so an icon's own size class still wins.
        <span className="contents [:where(&)_svg]:size-auto">
          {label ?? children}
        </span>
      )}
      {endIcon}
    </>
  );
}
